module.exports = __webpack_public_path__ + "static/media/complexity.a295ed2e.jpg";